/**
 * Product Page Enhancements
 * 1. Sticky Add to Cart bar
 * 2. Image zoom on hover (desktop)
 * 3. Discount badge on image
 * 4. Mobile gallery counter
 * 5. Trust badges
 */

document.addEventListener('DOMContentLoaded', () => {

  /* ========== 1. STICKY ADD TO CART BAR ========== */
  (() => {
    const buyButtons = document.querySelector('.product__buy_buttons');
    if (!buyButtons) return;

    const productTitle = document.querySelector('.product__title')?.textContent?.trim() || '';
    const priceEl = document.querySelector('.price--product .price-item--regular, .price--product .price-item--sale');
    const compareEl = document.querySelector('.price--product .price-item--regular');
    const saleEl = document.querySelector('.price--product .price-item--sale');
    const productImage = document.querySelector('.product__media-item img');
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');

    let priceHTML = '';
    if (saleEl && compareEl && saleEl !== compareEl) {
      priceHTML = `${saleEl.textContent.trim()} <s>${compareEl.textContent.trim()}</s>`;
    } else if (priceEl) {
      priceHTML = priceEl.textContent.trim();
    }

    const stickyBar = document.createElement('div');
    stickyBar.className = 'sticky-atc';
    stickyBar.innerHTML = `
      <div class="sticky-atc__inner">
        <div class="sticky-atc__info">
          ${productImage ? `<img class="sticky-atc__image" src="${productImage.src}" alt="${productTitle}">` : ''}
          <div class="sticky-atc__details">
            <p class="sticky-atc__title">${productTitle}</p>
            <p class="sticky-atc__price">${priceHTML}</p>
          </div>
        </div>
        <button class="sticky-atc__button" type="button">Agregar al carrito</button>
      </div>
    `;

    document.body.appendChild(stickyBar);

    // Click handler — submit the real product form
    stickyBar.querySelector('.sticky-atc__button').addEventListener('click', () => {
      const submitBtn = productForm?.querySelector('[type="submit"]');
      if (submitBtn && !submitBtn.disabled) {
        submitBtn.click();
      }
    });

    // Show/hide based on scroll position
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(buyButtons);
  })();


  /* ========== 2. IMAGE ZOOM ON HOVER (DESKTOP) ========== */
  (() => {
    if (window.innerWidth < 1200) return;

    document.querySelectorAll('.product__media-item .product__media').forEach(media => {
      const img = media.querySelector('img');
      if (!img) return;

      media.addEventListener('mousemove', (e) => {
        const rect = media.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
        media.classList.add('is-zoomed');
      });

      media.addEventListener('mouseleave', () => {
        media.classList.remove('is-zoomed');
        img.style.transformOrigin = 'center center';
      });

      media.addEventListener('click', () => {
        media.classList.toggle('is-zoomed');
      });
    });
  })();


  /* ========== 3. DISCOUNT BADGE ON IMAGE ========== */
  (() => {
    const comparePrice = document.querySelector('.price--product .price-item--regular');
    const salePrice = document.querySelector('.price--product .price-item--sale');

    if (!comparePrice || !salePrice || comparePrice === salePrice) return;

    const parseMoney = (str) => {
      const num = str.replace(/[^0-9.,]/g, '').replace(',', '');
      return parseFloat(num);
    };

    const compare = parseMoney(comparePrice.textContent);
    const sale = parseMoney(salePrice.textContent);

    if (!compare || !sale || sale >= compare) return;

    const percent = Math.round(((compare - sale) / compare) * 100);

    const firstSlide = document.querySelector('.product__media-item');
    if (!firstSlide) return;

    const badge = document.createElement('div');
    badge.className = 'product-badge-discount';
    badge.innerHTML = `<span class="product-badge-discount__percent">-${percent}%</span> OFF`;
    firstSlide.appendChild(badge);
  })();


  /* ========== 4. MOBILE GALLERY COUNTER ========== */
  (() => {
    if (window.innerWidth > 749) return;

    const wrapper = document.querySelector('.product__media-list-wrapper');
    const slides = document.querySelectorAll('.product__media-list .product__media-item, .product__media-list .swiper-slide');

    if (!wrapper || slides.length < 2) return;

    const counter = document.createElement('div');
    counter.className = 'gallery-counter';
    counter.textContent = `1 / ${slides.length}`;
    wrapper.appendChild(counter);

    // Try to hook into Swiper instance
    const swiperEl = document.querySelector('.product__media-list.swiper');

    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.on('slideChange', () => {
        counter.textContent = `${swiperEl.swiper.activeIndex + 1} / ${slides.length}`;
      });
    } else {
      // Fallback: watch scroll position for native scroll
      const mediaList = document.querySelector('.product__media-list');
      if (mediaList) {
        let ticking = false;
        mediaList.addEventListener('scroll', () => {
          if (!ticking) {
            requestAnimationFrame(() => {
              const scrollLeft = mediaList.scrollLeft;
              const slideWidth = mediaList.offsetWidth;
              const currentSlide = Math.round(scrollLeft / slideWidth) + 1;
              counter.textContent = `${currentSlide} / ${slides.length}`;
              ticking = false;
            });
            ticking = true;
          }
        });
      }
    }

    // Also try observing Swiper after it initializes (delayed)
    setTimeout(() => {
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.on('slideChange', () => {
          counter.textContent = `${swiperEl.swiper.activeIndex + 1} / ${slides.length}`;
        });
      }
    }, 1000);
  })();


  /* ========== 5. TRUST BADGES ========== */
  (() => {
    const buyButtons = document.querySelector('.product__buy_buttons');
    if (!buyButtons) return;

    const trustHTML = `
      <div class="trust-badges">
        <div class="trust-badge">
          <svg class="trust-badge__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="3" width="15" height="13" rx="2" ry="2"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
          </svg>
          <span class="trust-badge__label">Envío gratis</span>
        </div>
        <div class="trust-badge">
          <svg class="trust-badge__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
          </svg>
          <span class="trust-badge__label">Devolución fácil</span>
        </div>
        <div class="trust-badge">
          <svg class="trust-badge__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
          <span class="trust-badge__label">Pago seguro</span>
        </div>
        <div class="trust-badge">
          <svg class="trust-badge__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
          </svg>
          <span class="trust-badge__label">100% original</span>
        </div>
      </div>
    `;

    buyButtons.insertAdjacentHTML('afterend', trustHTML);
  })();

});